/* src/modules/discounts/actions.js */

import {
  fetchDiscountHoldersTypes,
  fetchSeasonsTypes,
  createSeasonTypes,
  createDiscountHolderTypes,
  createDiscountTypes,
  modifyActiveDiscountTypes,
  modifyDiscountHolderTypes,
  SELECT_DISCOUNT_HOLDER,
} from './action_types';

import {
  FETCH_DISCOUNT_HOLDERS_QUERY,
  FETCH_SEASONS_QUERY,
  CREATE_SEASON_MUTATION,
  CREATE_DISCOUNT_HOLDER_MUTATION,
  CREATE_DISCOUNT_MUTATION,
  MODIFY_ACTIVE_DISCOUNT_MUTATION,
  MODIFY_DISCOUNT_HOLDER_MUTATION,
} from './api';

import { makeQuery, makeMutation } from '../../config/client';

export const fetchDiscountHolders = variables => makeQuery(variables)(
  fetchDiscountHoldersTypes,
  FETCH_DISCOUNT_HOLDERS_QUERY
);

export const fetchSeasons = variables => makeQuery(variables)(
  fetchSeasonsTypes,
  FETCH_SEASONS_QUERY
);

export const createSeason = variables => makeMutation({ variables })(
  createSeasonTypes,
  CREATE_SEASON_MUTATION
);

export const createDiscountHolder = variables => makeMutation({ variables })(
  createDiscountHolderTypes,
  CREATE_DISCOUNT_HOLDER_MUTATION
);

export const createDiscount = variables => makeMutation({ variables })(
  createDiscountTypes,
  CREATE_DISCOUNT_MUTATION
);

export const modifyActiveDiscount = variables => makeMutation({ variables })(
  modifyActiveDiscountTypes,
  MODIFY_ACTIVE_DISCOUNT_MUTATION
);

export const modifyDiscountHolder = variables => makeMutation({ variables })(
  modifyDiscountHolderTypes,
  MODIFY_DISCOUNT_HOLDER_MUTATION
);

export const selectDiscountHolder = payload => ({
  type: SELECT_DISCOUNT_HOLDER,
  payload,
});



// WEBPACK FOOTER //
// ./src/modules/discounts/actions.js